import { Description, RadioButton, RadioGroup } from '@opengov/component-library/dist';
import { BasicColumnTypes } from '@opengov/ogql-types';
import { IConditionalReportColumn } from '@opengov/reporting-types';
import React from 'react';

import { IReportLocale } from '../../../../locale';

export interface IFirstConditionalStep {
  reportLocaleText: IReportLocale;
  conditional: IConditionalReportColumn<any>;
  updateColumnType(columnType: BasicColumnTypes): void;
}
export class Step1 extends React.Component<IFirstConditionalStep> {
  render() {
    const {
      conditional,
      reportLocaleText: {
        calculations: {
          conditionalModal: {
            textColumn,
            textColumnDescription,
            textColumnExamples,
            numberColumn,
            numberColumnDescription,
            numberColumnExamples,
            currencyColumn,
            currencyColumnDescription,
            currencyColumnExamples,
            percentageColumn,
            percentageColumnDescription,
            percentageColumnExamples,
            dateColumn,
            dateColumnDescription,
            dateColumnExamples
          }
        }
      },
      updateColumnType
    } = this.props;

    return (
      <div>
        <RadioGroup dataTest="conditional-type-radio-group" value={conditional.type} onChange={updateColumnType}>
          <RadioButton
            dataTest="conditional-radio-text"
            label={textColumn}
            value={BasicColumnTypes.Text}
            selected={conditional.type === BasicColumnTypes.Text}
            description={
              <div>
                <Description variant="condensed">{textColumnDescription}</Description>
                <Description variant="condensed">{textColumnExamples}</Description>
              </div>
            }
          />
          <RadioButton
            dataTest="conditional-radio-number"
            label={numberColumn}
            value={BasicColumnTypes.Numeric}
            selected={conditional.type === BasicColumnTypes.Numeric}
            description={
              <div>
                <Description variant="condensed">{numberColumnDescription}</Description>
                <Description variant="condensed">{numberColumnExamples}</Description>
              </div>
            }
          />
          <RadioButton
            dataTest="conditional-radio-currency"
            label={currencyColumn}
            value={BasicColumnTypes.Currency}
            selected={conditional.type === BasicColumnTypes.Currency}
            description={
              <div>
                <Description variant="condensed">{currencyColumnDescription}</Description>
                <Description variant="condensed">{currencyColumnExamples}</Description>
              </div>
            }
          />
          <RadioButton
            dataTest="conditional-radio-percent"
            label={percentageColumn}
            value={BasicColumnTypes.Percent}
            selected={conditional.type === BasicColumnTypes.Percent}
            description={
              <div>
                <Description variant="condensed">{percentageColumnDescription}</Description>
                <Description variant="condensed">{percentageColumnExamples}</Description>
              </div>
            }
          />
          <RadioButton
            dataTest="conditional-radio-date"
            label={dateColumn}
            value={BasicColumnTypes.Date}
            selected={conditional.type === BasicColumnTypes.Date}
            description={
              <div>
                <Description variant="condensed">{dateColumnDescription}</Description>
                <Description variant="condensed">{dateColumnExamples}</Description>
              </div>
            }
          />
        </RadioGroup>
      </div>
    );
  }
}
